import type { MouseEvent } from 'react';
import usePPVManagement from '../../../hooks/usePPVManagement';
import user from '../../../helpers/user';
import { PromotionItem, PromotionButtonsObject } from '../types/VerticalBlock.types';
import { showGuestPromotionPopup } from '../../../guest';

export const useVerticalBlockComputations = (item: PromotionItem, buttonsObject: PromotionButtonsObject) => {
    const { shouldShowLock } = usePPVManagement();
    const { isLocked } = shouldShowLock(item);

    const { play, reminder, watchlist, details } = buttonsObject;

    const isLockedLinear = isLocked && ['LIVESTREAM', 'CHANNEL'].includes(item.promoType);

    const getIconName = () => {
        if (isLocked && item.promoType !== 'SUBSCRIPTION') return 'locked';
        if (reminder) return 'remind';
        return undefined;
    };

    const getDetailsButtonProps = (onItemClick: (item: PromotionItem) => void) => {
        if (!details) return undefined;
        if (['SUBSCRIPTION', 'TIER'].includes(item.promoType)) {
            return {
                onClick: (e: MouseEvent<HTMLButtonElement>) => {
                    e.stopPropagation();
                    if (showGuestPromotionPopup(e)) {
                        return;
                    }
                    window.location.href = user.getUserProfileUrl();
                },
            };
        }
        if (isLocked) return undefined;
        return {
            onClick: (e: MouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                onItemClick(item);
            },
        };
    };

    return {
        play,
        reminder,
        watchlist,
        details,
        getIconName,
        getDetailsButtonProps,
        isLockedLinear,
    };
};
